import { lazy } from 'react';

const lazyWithPreload = (factory) => {
  let promise = null;
  const load = () => {
    if (!promise) promise = factory();
    return promise;
  };
  const Component = lazy(load);
  Component.preload = load;
  return Component;
};

export const Home = lazyWithPreload(() => import('components/home/home'));
export const Reports = lazyWithPreload(() => import('components/Reports/index'));
export const Analytics = lazyWithPreload(() => import('components/Dashboard/Analytics/index'));
export const Admin = lazyWithPreload(() => import('components/Admin'));
export const Settings = lazyWithPreload(() => import('components/Settings'));
